import React from "react";
import {Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, CircularProgress, Typography} from "@mui/material";

export const KpiPhoneTable = ({data, loading}) => {
    if (loading) {
        return (
            <Box sx={{display: 'flex', justifyContent: 'center', p: 4}}>
                <CircularProgress/>
            </Box>
        );
    }

    if (!data || data.length === 0) {
        return (
            <Typography sx={{p: 2, textAlign: 'center'}}>No data available</Typography>
        );
    }

    const calculateTotal = (field) => {
        return data.reduce((sum, row) => {
            const value = parseFloat(row[field]) || 0;
            return sum + value;
        }, 0);
    };

    const formatValue = (value, isPercent = false) => {
        if (value === null || value === undefined) return '0';
        if (isPercent) {
            return parseFloat(value).toFixed(1);
        }
        return value;
    };

    const formatDuration = (value) => {
        if (!value) return '0';
        return value;
    };

    return (
        <TableContainer component={Paper} sx={{maxHeight: 600}}>
            <Table stickyHeader size="small">
                <TableHead>
                    <TableRow>
                        <TableCell sx={{whiteSpace: 'nowrap'}}>KPI User</TableCell>
                        <TableCell align="right" sx={{whiteSpace: 'nowrap'}}>Outgoing calls</TableCell>
                        <TableCell align="right" sx={{whiteSpace: 'nowrap'}}>Outgoing calls %</TableCell>
                        <TableCell align="right" sx={{whiteSpace: 'nowrap'}}>Outgoing calls(&gt;30)</TableCell>
                        <TableCell align="right" sx={{whiteSpace: 'nowrap'}}>Incoming calls</TableCell>
                        <TableCell align="right" sx={{whiteSpace: 'nowrap'}}>Incoming calls %</TableCell>
                        <TableCell align="right" sx={{whiteSpace: 'nowrap'}}>Inbound call duration</TableCell>
                        <TableCell align="right" sx={{whiteSpace: 'nowrap'}}>Outbound call duration</TableCell>
                        <TableCell align="right" sx={{whiteSpace: 'nowrap'}}>Total call duration</TableCell>
                        <TableCell align="right" sx={{whiteSpace: 'nowrap'}}>Phone to Onsite</TableCell>
                        <TableCell align="right" sx={{whiteSpace: 'nowrap'}}>Phone to Inside</TableCell>
                        <TableCell align="right" sx={{whiteSpace: 'nowrap'}}>SMS</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {data.map((row, index) => (
                        <TableRow 
                            key={index}
                            sx={{
                                backgroundColor: row.totalCount === 0 ? '#ffebee' : 
                                                row.firstContactMode >= 15 ? '#e8f5e9' : 
                                                row.totalCount < 2 ? '#fff9c4' : 'inherit'
                            }}
                        >
                            <TableCell sx={{whiteSpace: 'nowrap'}}>{row.name || ''}</TableCell>
                            <TableCell align="right" sx={{whiteSpace: 'nowrap'}}>{formatValue(row.outbound_calls_count)}</TableCell>
                            <TableCell align="right" sx={{whiteSpace: 'nowrap'}}>{formatValue(row.percentOutboundCalls, true)}%</TableCell>
                            <TableCell align="right" sx={{whiteSpace: 'nowrap'}}>{formatValue(row.outgoing_calls_30_count)}</TableCell>
                            <TableCell align="right" sx={{whiteSpace: 'nowrap'}}>{formatValue(row.inbound_calls_count)}</TableCell>
                            <TableCell align="right" sx={{whiteSpace: 'nowrap'}}>{formatValue(row.percentInboundCalls, true)}%</TableCell>
                            <TableCell align="right" sx={{whiteSpace: 'nowrap'}}>{formatDuration(row.inbound_calls_dur)}</TableCell>
                            <TableCell align="right" sx={{whiteSpace: 'nowrap'}}>{formatDuration(row.outbound_calls_dur)}</TableCell>
                            <TableCell align="right" sx={{whiteSpace: 'nowrap'}}>{formatDuration(row.total_calls_duration)}</TableCell>
                            <TableCell align="right" sx={{whiteSpace: 'nowrap'}}>{formatValue(row.phone_outside)}</TableCell>
                            <TableCell align="right" sx={{whiteSpace: 'nowrap'}}>{formatValue(row.phone_inside)}</TableCell>
                            <TableCell align="right" sx={{whiteSpace: 'nowrap'}}>{formatValue(row.sms_count)}</TableCell>
                        </TableRow>
                    ))}
                    <TableRow sx={{backgroundColor: '#f5f5f5', fontWeight: 'bold'}}>
                        <TableCell sx={{whiteSpace: 'nowrap'}}><strong>Total</strong></TableCell>
                        <TableCell align="right" sx={{whiteSpace: 'nowrap'}}><strong>{calculateTotal('outbound_calls_count')}</strong></TableCell>
                        <TableCell align="right" sx={{whiteSpace: 'nowrap'}}></TableCell>
                        <TableCell align="right" sx={{whiteSpace: 'nowrap'}}></TableCell>
                        <TableCell align="right" sx={{whiteSpace: 'nowrap'}}><strong>{calculateTotal('inbound_calls_count')}</strong></TableCell>
                        <TableCell align="right" sx={{whiteSpace: 'nowrap'}}></TableCell>
                        <TableCell align="right" sx={{whiteSpace: 'nowrap'}}></TableCell>
                        <TableCell align="right" sx={{whiteSpace: 'nowrap'}}></TableCell>
                        <TableCell align="right" sx={{whiteSpace: 'nowrap'}}></TableCell>
                        <TableCell align="right" sx={{whiteSpace: 'nowrap'}}><strong>{calculateTotal('phone_outside')}</strong></TableCell>
                        <TableCell align="right" sx={{whiteSpace: 'nowrap'}}><strong>{calculateTotal('phone_inside')}</strong></TableCell>
                        <TableCell align="right" sx={{whiteSpace: 'nowrap'}}><strong>{calculateTotal('sms_count')}</strong></TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>
    );
};

